import { render, staticRenderFns } from "./PageEditorEditorToolbar.vue?vue&type=template&id=c39c7ab0&scoped=true"
import script from "./PageEditorEditorToolbar.vue?vue&type=script&lang=js"
export * from "./PageEditorEditorToolbar.vue?vue&type=script&lang=js"
import style0 from "./PageEditorEditorToolbar.vue?vue&type=style&index=0&id=c39c7ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39c7ab0",
  null
  
)

export default component.exports